// extracted by mini-css-extract-plugin
export var closeButton = "_ir-1";
export var closeX = "_ir-3";
export var container = "_ir-0";
export var image = "_ir-2";